(function() {
    "use strict";
    const AGE_MAP = {
            under_30: 25,
            "30_39": 35,
            "40_49": 45,
            "50_59": 55,
            over_60: 65
        },
        AGE_ORDER = ["under_30", "30_39", "40_49", "50_59", "over_60"],
        PROBLEM_LABELS = {
            beer_belly: "Midsection weight",
            man_boobs: "Chest area",
            low_t: "Hormonal imbalance",
            high_cortisol: "High Cortisol",
            low_energy: "Low Energy/Libido",
            low_muscle: "Low Muscle Mass"
        },
        FRUSTRATION_LABELS = {
            stubborn_weight_gain: "stubborn weight gain",
            aching_joints: "aching joints & stiffness",
            poor_sleep: "poor sleep",
            hot_flashes_night_sweats: "hot flashes & night sweats",
            mood_swings_brain_fog: "mood swings & brain fog",
            loss_libido: "loss of libido",
            not_myself: "not feeling like yourself"
        },
        LIFE_CHANGE_LABELS = {
            sleep_through_night: "sleeping through the night",
            joint_relief: "waking without stiff, aching joints",
            belly_fat_loss: "losing the menopause belly",
            emotional_balance: "feeling emotionally steady",
            hot_flashes_ease: "cooling off the hot flashes",
            feel_like_myself: "feeling like myself again"
        },
        LIFE_CHANGE_SCORE_WEIGHT = {
            sleep_through_night: 13,
            joint_relief: 12,
            belly_fat_loss: 11,
            emotional_balance: 10,
            hot_flashes_ease: 12,
            feel_like_myself: 11
        };
    class gwQuiz {
        constructor(container) {
            this.container = container, this.sectionId = container.dataset.sectionId, this.redirectUrl = container.dataset.redirectUrl;
            const dataEl = document.getElementById(`gw-quiz-data-${this.sectionId}`);
            this.config = dataEl ? JSON.parse(dataEl.textContent) : {}, this.state = {
                currentStep: 0,
                answers: {},
                history: []
            }, this.steps = Array.from(container.querySelectorAll(".gw-quiz__step")), this.progressBar = container.querySelector(".gw-quiz__progress-bar"), this.progressContainer = container.querySelector(".gw-quiz__progress"), this.autoAdvanceTimer = null, this.checklistTimers = [], this.init()
        }
        init() {
            this.clearState(), this.bindEvents(), this.showStep(this.state.currentStep), this.updateProgress()
        }
        bindEvents() {
            this.container.addEventListener("click", e => {
                const option = e.target.closest(".gw-quiz__option");
                option && this.handleOptionSelect(option), e.target.closest('[data-action="continue"]') && this.nextStep(), e.target.closest('[data-action="back"]') && this.prevStep();
                const claimBtn = e.target.closest('[data-action="claim-offer"]');
                claimBtn && this.handleClaimOffer(claimBtn);
                const skipBtn = e.target.closest('[data-action="skip"]');
                skipBtn && this.handleSkip(skipBtn);
                const unitBtn = e.target.closest(".gw-quiz__unit-btn");
                unitBtn && this.handleUnitToggle(unitBtn)
            }), this.container.addEventListener("keydown", e => {
                if (e.key === "Enter" || e.key === " ") {
                    const option = e.target.closest(".gw-quiz__option");
                    option && (e.preventDefault(), this.handleOptionSelect(option))
                }
            }), this.container.addEventListener("input", e => {
                const input = e.target.closest(".gw-quiz__input");
                input && this.handleInputChange(input);
                const measInput = e.target.closest(".gw-quiz__measurement-input");
                measInput && this.handleMeasurementChange(measInput)
            }), this.container.addEventListener("keydown", e => {
                if (e.key === "Enter") {
                    const input = e.target.closest(".gw-quiz__input") || e.target.closest(".gw-quiz__measurement-input");
                    if (input) {
                        const continueBtn = input.closest(".gw-quiz__step")?.querySelector('[data-action="continue"]');
                        continueBtn && !continueBtn.disabled && this.nextStep()
                    }
                }
            })
        }
        handleInputChange(input) {
            const step = input.closest(".gw-quiz__step"),
                questionId = step.dataset.questionId,
                value = input.value.trim(),
                inputType = input.type,
                min = input.min ? parseInt(input.min, 10) : null,
                max = input.max ? parseInt(input.max, 10) : null,
                required = input.hasAttribute("required");
            let isValid = !0;
            const errorEl = step.querySelector(".gw-quiz__input-error");
            if (required && !value) isValid = !1;
            else if (inputType === "number" && value) {
                const numVal = parseInt(value, 10);
                (isNaN(numVal) || min !== null && numVal < min || max !== null && numVal > max) && (isValid = !1)
            } else inputType === "email" && value && (isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value));
            input.classList.toggle("is-invalid", !isValid && value.length > 0), errorEl && (errorEl.hidden = isValid || value.length === 0), isValid && value ? (this.state.answers[questionId] = {
                value,
                label: value
            }, this.saveState()) : delete this.state.answers[questionId];
            const continueBtn = step.querySelector('[data-action="continue"]');
            continueBtn && (continueBtn.disabled = !isValid || !value)
        }
        handleUnitToggle(btn) {
            const toggle = btn.closest(".gw-quiz__unit-toggle"),
                step = btn.closest(".gw-quiz__step"),
                unit = btn.dataset.unit,
                wrapper = step.querySelector(".gw-quiz__measurement-wrapper");
            toggle.querySelectorAll(".gw-quiz__unit-btn").forEach(b => b.classList.remove("is-active")), btn.classList.add("is-active"), wrapper.dataset.activeUnit = unit, wrapper.querySelectorAll(".gw-quiz__measurement-fields").forEach(group => {
                group.hidden = group.dataset.unitGroup !== unit
            }), wrapper.querySelectorAll(".gw-quiz__measurement-fields[hidden] .gw-quiz__measurement-input").forEach(input => {
                input.value = ""
            });
            const visibleInput = wrapper.querySelector(".gw-quiz__measurement-fields:not([hidden]) .gw-quiz__measurement-input");
            if (visibleInput) this.handleMeasurementChange(visibleInput);
            else {
                const continueBtn = step.querySelector('[data-action="continue"]');
                continueBtn && (continueBtn.disabled = !0)
            }
        }
        handleMeasurementChange(input) {
            const step = input.closest(".gw-quiz__step"),
                questionId = step.dataset.questionId,
                measurementType = step.dataset.measurementType,
                wrapper = step.querySelector(".gw-quiz__measurement-wrapper"),
                activeUnit = wrapper.dataset.activeUnit,
                fields = wrapper.querySelector(`.gw-quiz__measurement-fields[data-unit-group="${activeUnit}"]`),
                inputs = fields.querySelectorAll(".gw-quiz__measurement-input"),
                errorEl = step.querySelector(".gw-quiz__input-error"),
                continueBtn = step.querySelector('[data-action="continue"]');
            let isValid = !0,
                displayValue = "",
                rawValue = "";
            if (measurementType === "height" && activeUnit === "imperial") {
                const feetInput = fields.querySelector('[data-measurement="feet"]'),
                    inchesInput = fields.querySelector('[data-measurement="inches"]'),
                    feet = feetInput.value.trim(),
                    inches = inchesInput.value.trim();
                if (!feet && !inches) isValid = !1;
                else {
                    const feetNum = parseInt(feet, 10),
                        inchesNum = parseInt(inches || "0", 10);
                    feet && (isNaN(feetNum) || feetNum < 3 || feetNum > 8) && (isValid = !1), inches && (isNaN(inchesNum) || inchesNum < 0 || inchesNum > 11) && (isValid = !1), feet || (isValid = !1), isValid && (displayValue = `${feetNum}'${inchesNum}"`, rawValue = `${feetNum}ft ${inchesNum}in`)
                }
            } else {
                const singleInput = inputs[0],
                    val = singleInput.value.trim(),
                    min = parseInt(singleInput.min, 10),
                    max = parseInt(singleInput.max, 10);
                if (!val) isValid = !1;
                else {
                    const numVal = parseInt(val, 10);
                    if (isNaN(numVal) || numVal < min || numVal > max) isValid = !1;
                    else {
                        const unit = singleInput.dataset.measurement;
                        displayValue = `${numVal} ${unit}`, rawValue = `${numVal} ${unit}`
                    }
                }
            }
            errorEl && (errorEl.hidden = isValid || !this.hasMeasurementInput(fields)), isValid ? (this.state.answers[questionId] = {
                value: rawValue,
                label: displayValue,
                unit: activeUnit
            }, this.saveState()) : delete this.state.answers[questionId], continueBtn && (continueBtn.disabled = !isValid)
        }
        hasMeasurementInput(fields) {
            return Array.from(fields.querySelectorAll(".gw-quiz__measurement-input")).some(i => i.value.trim().length > 0)
        }
        handleOptionSelect(option) {
            const step = option.closest(".gw-quiz__step"),
                questionId = step.dataset.questionId,
                selectionType = step.dataset.selectionType,
                autoAdvance = step.dataset.autoAdvance === "true",
                value = option.dataset.optionValue,
                label = option.dataset.optionLabel;
            if (selectionType === "single")
                if (step.querySelectorAll(".gw-quiz__option").forEach(opt => {
                        opt.classList.remove("is-selected"), opt.setAttribute("aria-pressed", "false")
                    }), option.classList.add("is-selected"), option.setAttribute("aria-pressed", "true"), this.state.answers[questionId] = {
                        value,
                        label
                    }, this.saveState(), autoAdvance) setTimeout(() => this.nextStep(), 300);
                else {
                    const continueBtn = step.querySelector('[data-action="continue"]');
                    continueBtn && (continueBtn.disabled = !1)
                }
            else {
                option.classList.toggle("is-selected");
                const isSelected = option.classList.contains("is-selected");
                option.setAttribute("aria-pressed", isSelected ? "true" : "false");
                const selectedOptions = Array.from(step.querySelectorAll(".gw-quiz__option.is-selected"));
                this.state.answers[questionId] = selectedOptions.map(opt => ({
                    value: opt.dataset.optionValue,
                    label: opt.dataset.optionLabel
                })), this.saveState();
                const continueBtn = step.querySelector('[data-action="continue"]');
                continueBtn && (continueBtn.disabled = selectedOptions.length === 0)
            }
        }
        showStep(index) {
            this.clearTimers(), this.steps.forEach((step, i) => {
                i === index ? (step.classList.add("is-active"), step.classList.remove("is-exiting")) : step.classList.remove("is-active")
            });
            const currentStep = this.steps[index];
            if (!currentStep) return;
            const stepType = currentStep.dataset.stepType;
            setTimeout(() => {
                const inputField = currentStep.querySelector(".gw-quiz__input");
                inputField && inputField.focus()
            }, 100), (stepType === "question_image" || stepType === "question_text") && this.restoreSelections(currentStep), stepType === "question_input" && this.restoreInputValue(currentStep), stepType === "summary_profile" && this.populateSummaryProfile(currentStep), stepType === "summary_results" && this.populateSummaryResults(currentStep), stepType === "summary_comparison" && this.populateSummaryComparison(currentStep), stepType === "loading_step" && this.handleLoadingStep(currentStep), stepType === "info_step" && this.populateInfoStep(currentStep), stepType === "offer_step" && (this.populateOfferStep(currentStep), this.initOfferCarousel(currentStep)), this.updateProgress(), ((w) => {
                w && (w.scrollTop = 0)
            })(this.container.querySelector(".gw-quiz__wrapper")), window.scrollTo({
                top: 0,
                behavior: "auto"
            })
        }
        restoreSelections(step) {
            const questionId = step.dataset.questionId,
                answer = this.state.answers[questionId];
            if (!answer) return;
            const values = step.dataset.selectionType === "multi" ? answer.map(a => a.value) : [answer.value];
            step.querySelectorAll(".gw-quiz__option").forEach(option => {
                const optValue = option.dataset.optionValue;
                values.includes(optValue) && (option.classList.add("is-selected"), option.setAttribute("aria-pressed", "true"))
            });
            const continueBtn = step.querySelector('[data-action="continue"]');
            continueBtn && values.length > 0 && (continueBtn.disabled = !1)
        }
        restoreInputValue(step) {
            const questionId = step.dataset.questionId,
                answer = this.state.answers[questionId],
                measurementType = step.dataset.measurementType;
            if (measurementType && answer) {
                const unit = answer.unit || "imperial",
                    wrapper = step.querySelector(".gw-quiz__measurement-wrapper"),
                    toggle = step.querySelector(".gw-quiz__unit-toggle");
                if (toggle && toggle.querySelectorAll(".gw-quiz__unit-btn").forEach(btn => {
                        btn.classList.toggle("is-active", btn.dataset.unit === unit)
                    }), wrapper) {
                    wrapper.dataset.activeUnit = unit, wrapper.querySelectorAll(".gw-quiz__measurement-fields").forEach(group => {
                        group.hidden = group.dataset.unitGroup !== unit
                    });
                    const rawValue = answer.value || "",
                        fields = wrapper.querySelector(`.gw-quiz__measurement-fields[data-unit-group="${unit}"]`);
                    if (measurementType === "height" && unit === "imperial") {
                        const match = rawValue.match(/(\d+)ft\s*(\d+)in/);
                        if (match) {
                            const feetInput = fields.querySelector('[data-measurement="feet"]'),
                                inchesInput = fields.querySelector('[data-measurement="inches"]');
                            feetInput && (feetInput.value = match[1]), inchesInput && (inchesInput.value = match[2])
                        }
                    } else {
                        const match = rawValue.match(/(\d+)/);
                        if (match && fields) {
                            const input2 = fields.querySelector(".gw-quiz__measurement-input");
                            input2 && (input2.value = match[1])
                        }
                    }
                    const visibleInput = fields?.querySelector(".gw-quiz__measurement-input");
                    visibleInput && this.handleMeasurementChange(visibleInput)
                }
                return
            }
            const input = step.querySelector(".gw-quiz__input");
            !answer || !input || (input.value = answer.value || "", input.value && this.handleInputChange(input))
        }
        nextStep() {
            if (this.state.currentStep < this.steps.length - 1) {
                for (this.state.history.push(this.state.currentStep), this.state.currentStep++; this.state.currentStep < this.steps.length - 1 && this.shouldSkipStep(this.steps[this.state.currentStep]);) this.state.currentStep++;
                this.showStep(this.state.currentStep), this.updateProgress(), this.saveState()
            }
        }
        shouldSkipStep(step) {
            const skipIf = step.dataset.skipIf;
            if (!skipIf) return !1;
            const [questionId, valuesStr] = skipIf.split(":");
            if (!questionId || !valuesStr) return !1;
            const skipValues = valuesStr.split(",").map(v => v.trim()),
                answer = this.state.answers[questionId];
            return answer ? (Array.isArray(answer) ? answer.map(a => a.value) : [answer.value]).some(v => skipValues.includes(v)) : !1
        }
        prevStep() {
            this.state.history.length > 0 && (this.state.currentStep = this.state.history.pop(), this.showStep(this.state.currentStep), this.updateProgress(), this.saveState())
        }
        updateProgress() {
            const bar = this.container.querySelector(".gw-quiz__progress-bar") || document.querySelector(".gw-quiz__progress-bar"),
                wrapper = this.container.querySelector(".gw-quiz__progress") || document.querySelector(".gw-quiz__progress");
            if (!bar) return;
            const progress = this.state.currentStep / Math.max(this.steps.length - 1, 1) * 100;
            bar.style.setProperty("width", `${progress}%`, "important"), wrapper && wrapper.setAttribute("aria-valuenow", Math.round(progress))
        }
        answerValues(questionId) {
            const q = this.state.answers[questionId];
            return q ? Array.isArray(q) ? q.map(x => x.value).filter(Boolean) : q.value ? [q.value] : [] : []
        }
        getPerceivedAge() {
            const exactAge = this.state.answers.exact_age,
                ageRangeAnswer = this.state.answers.age;
            let baseAge;
            if (exactAge && exactAge.value) baseAge = parseInt(exactAge.value, 10);
            else if (ageRangeAnswer) baseAge = AGE_MAP[ageRangeAnswer.value] || 45;
            else return null;
            return baseAge + 10
        }
        getGoalAge() {
            const exactAge = this.state.answers.exact_age,
                ageRangeAnswer = this.state.answers.age;
            let baseAge;
            if (exactAge && exactAge.value) baseAge = parseInt(exactAge.value, 10);
            else if (ageRangeAnswer) baseAge = AGE_MAP[ageRangeAnswer.value] || 45;
            else return null;
            return baseAge - 8
        }
        getProblemAreasText(limit = 2) {
            const problemAreas = this.state.answers.problem_areas;
            if (problemAreas && Array.isArray(problemAreas) && problemAreas.length > 0) return problemAreas.slice(0, limit).map(p => PROBLEM_LABELS[p.value] || p.label).join(" & ");
            const fr = this.answerValues("frustrations_recent");
            return fr.length > 0 ? fr.slice(0, limit).map(v => FRUSTRATION_LABELS[v] || v.replace(/_/g, " ")).join(" & ") : "your concerns"
        }
        getDatePlus(days) {
            const date = new Date;
            return date.setDate(date.getDate() + days), date.toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric"
            })
        }
        populateSummaryProfile(step) {
            const scores = this.calculateTScores();
            this.populateProblemAreasVisual(step), this.populateBioAge(step, scores), this.populateClinicalSummary(step, scores), this.animateDashboard(step, scores)
        }
        calculateTScores() {
            const a = this.state.answers,
                val = key => a[key]?.value || "",
                vals = key => this.answerValues(key),
                mwMap = {
                    every_morning: 95,
                    most_mornings: 70,
                    occasionally: 40,
                    rarely: 15
                },
                acMap = {
                    never: 95,
                    sometimes: 65,
                    often: 35,
                    always: 10
                },
                mwKey = val("morning_wood"),
                acKey = val("afternoon_crash");
            let hormonal;
            if (mwKey && acKey && Object.prototype.hasOwnProperty.call(mwMap, mwKey) && Object.prototype.hasOwnProperty.call(acMap, acKey)) hormonal = Math.round(mwMap[mwKey] * .55 + acMap[acKey] * .45);
            else {
                const frustr = vals("frustrations_recent"),
                    frHit = {
                        stubborn_weight_gain: 10,
                        aching_joints: 13,
                        poor_sleep: 12,
                        hot_flashes_night_sweats: 14,
                        mood_swings_brain_fog: 10,
                        loss_libido: 12,
                        not_myself: 13
                    };
                let frScore = 50;
                if (frustr.length > 0) {
                    let sub = 0;
                    frustr.forEach(v => {
                        sub += frHit[v] ?? 11
                    }), frScore = Math.max(14, Math.round(97 - Math.min(sub, 70)))
                }
                const emScore = {
                        wired_tired: 40,
                        irritability_rage: 38,
                        anxiety_unrelenting: 32,
                        flat_foggy: 44,
                        calm_steady: 93
                    } [val("emotional_state_daily")] ?? 50,
                    sleepMap = {
                        wake_3am: 22,
                        unrested: 40,
                        hot_flash_waking: 30,
                        cant_fall_asleep: 38,
                        sleep_fine: 90
                    },
                    sq = val("sleep_quality");
                let sleepScore;
                if (sq) sleepScore = sleepMap[sq] ?? 50;
                else {
                    const p = val("life_change_priority");
                    if (p) {
                        const drain = LIFE_CHANGE_SCORE_WEIGHT[p] ?? 10;
                        sleepScore = Math.max(22, Math.round(93 - Math.min(drain, 52)))
                    } else sleepScore = 50
                }
                const stageScore = {
                    regular_cycles: 86,
                    irregular_cycles: 64,
                    perimenopause: 52,
                    menopause: 40,
                    post_menopause: 46
                } [val("life_stage")] ?? 50;
                hormonal = Math.round(frScore * .32 + emScore * .22 + sleepScore * .26 + stageScore * .2)
            }
            const exMap = {
                    "5_plus_week": 95,
                    "3_4_week": 72,
                    "1_2_week": 45,
                    rarely: 15
                },
                bfMap = {
                    flat: 95,
                    slight: 75,
                    moderate: 50,
                    significant: 25,
                    severe: 8
                },
                alMap = {
                    never: 95,
                    rarely: 80,
                    occasionally: 60,
                    regularly: 35,
                    daily: 10
                },
                hasLegacyLifestyle = !!(val("exercise") && val("belly_fat") && val("alcohol"));
            let lifestyle;
            if (hasLegacyLifestyle) {
                const exScore = exMap[val("exercise")],
                    bfScore = bfMap[val("belly_fat")],
                    alScore = alMap[val("alcohol")];
                lifestyle = Math.round(exScore * .4 + bfScore * .35 + alScore * .25)
            } else {
                const wtMap = {
                        gain_easier_now: 40,
                        belly_fat_sudden: 36,
                        nothing_seems_works: 28,
                        metabolism_slower: 44,
                        weight_stable_same: 88
                    },
                    crMap = {
                        constant_sugar: 34,
                        worse_at_night: 36,
                        snack_more_often: 42,
                        stress_overeating: 38,
                        appetite_normal: 91
                    },
                    wch = val("weight_change_recent"),
                    cr = val("cravings_appetite"),
                    tried = vals("already_tried"),
                    wSc = wch ? wtMap[wch] ?? 50 : 50,
                    cSc = cr ? crMap[cr] ?? 50 : 50;
                let triedBench = 50;
                if (tried.length > 0) {
                    triedBench = 76, tried.includes("nothing_really_worked") && (triedBench -= 22);
                    const otherN = tried.filter(t => t !== "nothing_really_worked").length;
                    triedBench -= Math.min(18, otherN * 4), triedBench = Math.max(18, triedBench)
                }
                if (wch || cr || tried.length > 0) {
                    const wMix = wch ? wSc : cSc * .92,
                        cMix = cr ? cSc : wSc * .92;
                    lifestyle = Math.round(wMix * .44 + cMix * .39 + triedBench * .17)
                } else {
                    const exScore = exMap[val("exercise")] ?? 50,
                        bfScore = bfMap[val("belly_fat")] ?? 50,
                        alScore = alMap[val("alcohol")] ?? 50;
                    lifestyle = Math.round(exScore * .4 + bfScore * .35 + alScore * .25)
                }
            }
            const bodyOrder = ["overweight", "soft", "slim", "skinny", "muscular"],
                dreamOrder = ["fit_healthy", "lean_toned", "slim_defined", "athletic", "muscular", "bulk_power"],
                btIdx = bodyOrder.indexOf(val("body_type")),
                dbIdx = dreamOrder.indexOf(val("dream_body"));
            let body;
            if (btIdx !== -1 && dbIdx !== -1) {
                const currentRank = [15, 35, 60, 50, 90][btIdx],
                    dreamDifficulty = [60, 70, 65, 80, 90, 95][dbIdx],
                    bodyGap = Math.max(0, dreamDifficulty - currentRank);
                body = Math.round(Math.max(5, Math.min(95, 95 - bodyGap)))
            } else {
                const wtMap = {
                        gain_easier_now: 40,
                        belly_fat_sudden: 34,
                        nothing_seems_works: 26,
                        metabolism_slower: 44,
                        weight_stable_same: 88
                    },
                    crMap = {
                        constant_sugar: 36,
                        worse_at_night: 38,
                        snack_more_often: 44,
                        stress_overeating: 40,
                        appetite_normal: 90
                    },
                    wch = val("weight_change_recent"),
                    cr = val("cravings_appetite");
                if (wch || cr) {
                    const wSc = wch ? wtMap[wch] ?? 50 : 50,
                        cSc = cr ? crMap[cr] ?? 50 : 50;
                    body = Math.round(wSc * .55 + cSc * .45)
                } else body = Math.round(Math.max(5, Math.min(95, 92)))
            }
            const baseAge = {
                    under_30: 27,
                    "30_39": 35,
                    "40_49": 45,
                    "50_59": 55,
                    over_60: 63
                } [val("age")] || 45,
                feelMap = {
                    no_older_than_age: 0,
                    slight_older_feeling: 5,
                    feels_10_years_older: 13,
                    body_feels_giving_up: 20
                },
                feelExtra = Object.prototype.hasOwnProperty.call(feelMap, val("feel_older_than_age")) ? feelMap[val("feel_older_than_age")] : 0,
                healthAvg = (hormonal + lifestyle) / 2,
                agePenalty = Math.round((100 - healthAvg) * .18 + feelExtra * .62),
                biologicalAge = baseAge + agePenalty,
                bioageScore = Math.round(Math.max(5, Math.min(95, healthAvg * .6 + (100 - agePenalty * 2) * .4))),
                MAX_METRIC = 58,
                MIN_AGE_PENALTY = 4,
                cappedHormonal = Math.min(hormonal, MAX_METRIC),
                cappedLifestyle = Math.min(lifestyle, MAX_METRIC),
                cappedBody = Math.min(body, MAX_METRIC),
                cappedBioage = Math.min(bioageScore, MAX_METRIC),
                cappedAgePenalty = Math.max(agePenalty, MIN_AGE_PENALTY),
                cappedBiologicalAge = baseAge + cappedAgePenalty;
            return {
                tscore: Math.min(MAX_METRIC, Math.round(cappedHormonal * .4 + cappedLifestyle * .3 + cappedBody * .2 + cappedBioage * .1)),
                hormonal: cappedHormonal,
                lifestyle: cappedLifestyle,
                body: cappedBody,
                bioage: cappedBioage,
                chronoAge: baseAge,
                biologicalAge: cappedBiologicalAge,
                agePenalty: cappedAgePenalty
            }
        }
        getSeverity(score) {
            return score <= 25 ? {
                level: "critical",
                label: "Critical",
                color: "#d64550"
            } : score <= 45 ? {
                level: "low",
                label: "Low",
                color: "#e8743f"
            } : score <= 60 ? {
                level: "below_avg",
                label: "Below Avg",
                color: "#e0a13b"
            } : score <= 78 ? {
                level: "average",
                label: "Fair",
                color: "#9bab4d"
            } : {
                level: "optimal",
                label: "Optimal",
                color: "#3da46a"
            }
        }
        getMetricDetail(key, score) {
            const sev = this.getSeverity(score),
                details = {
                    hormonal: {
                        critical: "Your cortisol rhythm looks badly disrupted \u2014 3am wake-ups, wired-but-tired evenings and flat mornings all point to a flattened curve.",
                        low: "Your cortisol curve appears out of sync, which can quietly fragment sleep and keep your body stuck in fight-or-flight.",
                        below_avg: "Signs of a disrupted cortisol rhythm linked to restless sleep and morning fatigue.",
                        average: "Your cortisol rhythm is mid-range \u2014 steadier sleep and calmer mornings are realistic once the curve resets.",
                        optimal: "Your answers suggest a relatively intact cortisol rhythm \u2014 a strong base for deep sleep and steady energy."
                    },
                    lifestyle: {
                        critical: "Inflammation load looks high \u2014 stiff joints, puffiness and slow recovery often travel together when the body can't calm down.",
                        low: "Your body may be carrying a heavy inflammatory load, which can show up as aching joints, swelling and stubborn belly fat.",
                        below_avg: "Elevated inflammation linked to joint stiffness and slower recovery.",
                        average: "Inflammation is present but workable \u2014 calming it tends to ease stiffness, puffiness and morning aches.",
                        optimal: "Inflammatory signals look well-controlled \u2014 that supports supple joints, clearer skin and easier mornings."
                    },
                    body: {
                        critical: "Your nervous system looks stuck in sympathetic 'alert' mode \u2014 hard to wind down, hard to stay asleep, hard to truly rest.",
                        low: "Autonomic balance appears tilted toward stress, so your body may struggle to drop into deep, repairing rest.",
                        below_avg: "Nervous system leaning toward fight-or-flight, making real rest harder.",
                        average: "Autonomic balance is okay but not optimized \u2014 nudging it toward 'rest and repair' can deepen sleep and steady mood.",
                        optimal: "Your nervous system appears to shift into rest-and-repair well \u2014 the foundation of deep sleep and calm energy."
                    },
                    bioage: {
                        critical: "Disconnection and stress load look like they're aging your body faster \u2014 sleep, energy and recovery all take the hit.",
                        low: "Several signals suggest your body is running older than your years \u2014 common, and very responsive to nightly grounding.",
                        below_avg: "Stress and disrupted sleep appear to be accelerating biological aging.",
                        average: "A few accelerated-aging signals are showing \u2014 protecting sleep and calming inflammation usually turns this around.",
                        optimal: "Your biological-age signals look comparatively young \u2014 a good position to protect sleep, mood and recovery long-term."
                    }
                };
            return details[key] && details[key][sev.level] || ""
        }
        getTScoreDescription(score) {
            return score <= 25 ? "Your grounding score suggests deep disconnection \u2014 cortisol, inflammation, sleep and your nervous system are all pulling against you right now." : score <= 45 ? "Your results point to meaningful disconnection \u2014 restoring nightly contact with the Earth usually creates fast, visible shifts in sleep and inflammation." : score <= 60 ? "You're slightly below where you'd want to feel \u2014 consistent grounding can ease restless sleep, morning stiffness and that wired-but-tired feeling." : score <= 78 ? "You're closer to balanced than you might feel \u2014 a few nights of grounded sleep can reset your cortisol curve and deepen recovery." : "Your grounding signals look strong \u2014 the priority now is protecting your sleep, rhythm and recovery so it stays that way."
        }
        populateProblemAreasVisual(step) {
            const problemAreasVisual = step.querySelector(".gw-quiz__problem-areas-visual"),
                problemAreas = this.state.answers.problem_areas;
            if (problemAreasVisual && problemAreas && Array.isArray(problemAreas) && problemAreas.length > 0) {
                const selectedAreas = problemAreas.slice(0, 3);
                let html = '<div class="gw-quiz__problem-areas-grid">';
                const imageMap = {
                        beer_belly: problemAreasVisual.dataset.imgBeerbelly,
                        man_boobs: problemAreasVisual.dataset.imgManboobs,
                        low_t: problemAreasVisual.dataset.imgLowt,
                        high_cortisol: problemAreasVisual.dataset.imgHighcortisol,
                        low_energy: problemAreasVisual.dataset.imgLowenergy,
                        low_muscle: problemAreasVisual.dataset.imgLowmuscle
                    },
                    labelMap = {
                        beer_belly: "Midsection weight",
                        man_boobs: "Chest area",
                        low_t: "Hormonal imbalance",
                        high_cortisol: "High Cortisol",
                        low_energy: "Low Energy/Libido",
                        low_muscle: "Low Muscle Mass"
                    };
                selectedAreas.forEach(area => {
                    const imageUrl = imageMap[area.value],
                        label = labelMap[area.value] || PROBLEM_LABELS[area.value] || area.label;
                    imageUrl && imageUrl.length > 10 && (html += `
              <div class="gw-quiz__problem-area-item">
                <img src="${imageUrl}" alt="${label}" class="gw-quiz__problem-area-img" loading="lazy">
                <span class="gw-quiz__problem-area-label">${label}</span>
              </div>
            `)
                }), html += "</div>", problemAreasVisual.innerHTML = html
            }
        }
        populateBioAge(step, scores) {
            const chronoEl = step.querySelector('[data-field="chrono_age"]'),
                bioEl = step.querySelector('[data-field="bio_age"]'),
                gapEl = step.querySelector('[data-field="age_gap"]');
            chronoEl && (chronoEl.textContent = scores.chronoAge), bioEl && (bioEl.textContent = scores.biologicalAge), gapEl && (gapEl.textContent = `+${scores.agePenalty} yrs`)
        }
        populateClinicalSummary(step, scores) {
            const el = step.querySelector('[data-field="clinical_summary"]');
            if (!el) return;
            const existing = el.textContent.trim();
            if (existing && existing !== "--") return;
            const problemAreasText = this.getProblemAreasText(),
                sev = this.getSeverity(scores.tscore);
            el.textContent = `Based on your answers, your grounding score of ${scores.tscore} (${sev.label}) suggests your ${problemAreasText} and a flattened cortisol rhythm are shaping how you sleep, ache and feel. Your body may be functioning like someone ${scores.biologicalAge} years old.`
        }
        animateDashboard(step, scores) {
            const GAUGE_CIRCUMFERENCE = 2 * Math.PI * 70,
                ANIM_DURATION = 1800,
                metrics = ["hormonal", "lifestyle", "body", "bioage"],
                gaugeFill = step.querySelector('[data-gauge="tscore"]'),
                gaugeCounter = step.querySelector('[data-counter="tscore"]'),
                gaugeBadge = step.querySelector('[data-severity="tscore"]'),
                gaugeDesc = step.querySelector('[data-desc="tscore"]');
            if (gaugeFill) {
                const sev = this.getSeverity(scores.tscore),
                    target = GAUGE_CIRCUMFERENCE * (1 - scores.tscore / 100);
                requestAnimationFrame(() => {
                    gaugeFill.style.strokeDashoffset = target, gaugeFill.style.stroke = sev.color
                }), gaugeBadge && (gaugeBadge.textContent = sev.label, gaugeBadge.setAttribute("data-level", sev.level)), gaugeDesc && (gaugeDesc.textContent = this.getTScoreDescription(scores.tscore))
            }
            gaugeCounter && this.animateCounter(gaugeCounter, scores.tscore, ANIM_DURATION), metrics.forEach((key, i) => {
                const score = scores[key],
                    sev = this.getSeverity(score),
                    delay = 600 + i * 150;
                setTimeout(() => {
                    const bar = step.querySelector(`[data-bar="${key}"]`),
                        counter = step.querySelector(`[data-counter="${key}"]`),
                        badge = step.querySelector(`[data-severity="${key}"]`),
                        detail = step.querySelector(`[data-detail="${key}"]`);
                    bar && (bar.style.width = `${score}%`, bar.style.backgroundColor = sev.color), counter && this.animateCounter(counter, score, 1400), badge && (badge.textContent = sev.label, badge.setAttribute("data-level", sev.level)), detail && (detail.textContent = this.getMetricDetail(key, score))
                }, delay)
            })
        }
        animateCounter(el, target, duration) {
            const start = performance.now(),
                from = 0,
                tick = now => {
                    const elapsed = now - start,
                        progress = Math.min(elapsed / duration, 1),
                        eased = 1 - Math.pow(1 - progress, 3);
                    el.textContent = Math.round(from + (target - from) * eased), progress < 1 && requestAnimationFrame(tick)
                };
            requestAnimationFrame(tick)
        }
        populateSummaryResults(step) {
            const answers = this.state.answers,
                val = key => answers[key]?.value || "",
                label = key => answers[key]?.label || "",
                date14 = this.getDatePlus(14),
                date30 = this.getDatePlus(30),
                date60 = this.getDatePlus(60),
                personalizedEl = step.querySelector("[data-sr-personalized]");
            if (personalizedEl) {
                const concerns = this.getProblemAreasTextBold(3),
                    age = label("age"),
                    motivation = val("motivation"),
                    motivationLine = {
                        extremely_motivated: "Your determination puts you ahead of most people juggling the same hormone, weight & sleep frustrations",
                        very_motivated: "Your commitment level is exactly what's needed",
                        motivated: "With the right support, you're set for real change",
                        somewhat: "Even small steps lead to big transformations"
                    } [motivation] || "You're taking the first step toward real change",
                    agePhrase = age ? ` in the <strong>${age}</strong> age group` : "";
                personalizedEl.innerHTML = `${motivationLine}. Based on your profile${agePhrase} dealing with ${concerns}, here's your personalized plan:`
            }
            const profileGrid = step.querySelector("[data-sr-profile]");
            if (profileGrid) {
                const pills = [],
                    addPill = (lbl, value) => {
                        value && pills.push(`<span class="gw-quiz__sr-profile-pill"><span class="gw-quiz__sr-profile-pill-label">${lbl}:</span> <span class="gw-quiz__sr-profile-pill-value">${value}</span></span>`)
                    };
                if (addPill("Age", label("age")), addPill("Body Type", label("body_type")), addPill("Goal", label("dream_body")), addPill("Exercise", label("exercise")), addPill("Belly Fat", label("belly_fat")), addPill("Life stage", label("life_stage")), label("sleep_quality")) addPill("Sleep", label("sleep_quality"));
                else {
                    const lifeChVals = this.answerValues("life_change_priority");
                    if (lifeChVals.length > 0) {
                        const lifeChLabels = lifeChVals.map(v => LIFE_CHANGE_LABELS[v] || v.replace(/_/g, " "));
                        addPill("Top priority", lifeChLabels.join(", "))
                    }
                }
                addPill("Daily mood", label("emotional_state_daily"));
                const frustrLabels = this.answerValues("frustrations_recent").map(v => FRUSTRATION_LABELS[v] || v.replace(/_/g, " "));
                frustrLabels.length && addPill("Top frustrations", frustrLabels.slice(0, 4).join(", ")), addPill("Recent weight pattern", label("weight_change_recent")), val("special_event") && val("special_event") !== "no_event" && val("special_event") !== "self_improvement" && addPill("Event", label("special_event")), profileGrid.innerHTML = pills.join("")
            }
            const eventDate = val("event_date"),
                countdownEl = step.querySelector("[data-sr-countdown]");
            if (eventDate && countdownEl) {
                const eventDateObj = new Date(eventDate + "T00:00:00"),
                    now = new Date;
                now.setHours(0, 0, 0, 0);
                const diffDays = Math.ceil((eventDateObj - now) / (1e3 * 60 * 60 * 24));
                if (diffDays > 0) {
                    const eventType = val("special_event"),
                        eventLabel = {
                            vacation: "Your trip",
                            wedding: "Your event",
                            fitness: "Your competition",
                            health_checkup: "Your checkup"
                        } [eventType] || "Your target date",
                        formattedDate = eventDateObj.toLocaleDateString("en-US", {
                            month: "long",
                            day: "numeric",
                            year: "numeric"
                        });
                    step.querySelector("[data-sr-countdown-label]").textContent = `${eventLabel}: ${formattedDate}`, step.querySelector("[data-sr-countdown-days]").textContent = `${diffDays} days away`, countdownEl.hidden = !1
                }
            }
            const d14El = step.querySelector("[data-sr-date-14]"),
                d30El = step.querySelector("[data-sr-date-30]"),
                d60El = step.querySelector("[data-sr-date-60]");
            d14El && (d14El.textContent = date14), d30El && (d30El.textContent = date30), d60El && (d60El.textContent = date60), step.querySelectorAll("[data-template]").forEach(el => {
                const template = el.dataset.template;
                el.innerHTML = template.replace("{date_14}", date14).replace("{date_30}", date30).replace("{date_60}", date60)
            });
            const benefitsEl = step.querySelector("[data-sr-benefits]");
            if (benefitsEl) {
                const problemAreas = answers.problem_areas,
                    benefitMap = {
                        beer_belly: "Target <strong>stubborn midsection weight</strong> with cortisol-lowering adaptogens",
                        man_boobs: "Support <strong>estrogen balance</strong> for a smoother upper-body silhouette",
                        low_t: "Naturally support <strong>hormonal balance</strong> through nightly grounded sleep",
                        high_cortisol: "Lower <strong>cortisol levels</strong> with proven stress-fighting herbs",
                        low_energy: "Restore <strong>all-day energy & drive</strong> starting in the first week",
                        low_muscle: "Accelerate <strong>lean muscle growth</strong> and workout recovery"
                    },
                    frustrationBenefitMap = {
                        stubborn_weight_gain: "Target <strong>stubborn menopause weight</strong> by lowering the cortisol that drives belly-fat storage",
                        aching_joints: "Calm <strong>aching joints & morning stiffness</strong> as nightly grounding lowers inflammation",
                        poor_sleep: "Rebuild <strong>deep, unbroken sleep</strong> by resyncing your cortisol rhythm overnight",
                        hot_flashes_night_sweats: "Cool <strong>hot flashes & night sweats</strong> as your nervous system settles into rest",
                        mood_swings_brain_fog: "Steady <strong>mood swings & brain fog</strong> by shifting out of fight-or-flight",
                        loss_libido: "Reawaken <strong>desire & vitality</strong> as stress load drops and sleep returns",
                        not_myself: "Help you feel <strong>like yourself again</strong> from the first grounded night"
                    },
                    lifeChangeBenefitMap = {
                        sleep_through_night: "Move toward <strong>deep, unbroken nights</strong> as your cortisol curve resets",
                        joint_relief: "Wake to <strong>looser, less achy joints</strong> as inflammation calms overnight",
                        belly_fat_loss: "Ease the <strong>menopause belly</strong> by lowering the cortisol that stores it",
                        emotional_balance: "Settle into a <strong>steadier, calmer baseline</strong> out of fight-or-flight",
                        hot_flashes_ease: "Soften <strong>hot flashes & night sweats</strong> as your nervous system rebalances",
                        feel_like_myself: "Rebuild the sense of <strong>feeling like you again</strong>, night by night"
                    },
                    checkSvg = '<svg class="gw-quiz__sr-benefit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>';
                let html = "";
                Array.isArray(problemAreas) && problemAreas.forEach(a => {
                    const text = benefitMap[a.value];
                    text && (html += `<div class="gw-quiz__sr-benefit">${checkSvg}<p class="gw-quiz__sr-benefit-text">${text}</p></div>`)
                }), this.answerValues("frustrations_recent").forEach(v => {
                    const text = frustrationBenefitMap[v];
                    text && (html += `<div class="gw-quiz__sr-benefit">${checkSvg}<p class="gw-quiz__sr-benefit-text">${text}</p></div>`)
                }), this.answerValues("life_change_priority").forEach(v => {
                    const text = lifeChangeBenefitMap[v];
                    text && (html += `<div class="gw-quiz__sr-benefit">${checkSvg}<p class="gw-quiz__sr-benefit-text">${text}</p></div>`)
                }), html || (html = `<div class="gw-quiz__sr-benefit">${checkSvg}<p class="gw-quiz__sr-benefit-text">Resync your <strong>cortisol rhythm</strong> through nightly grounded sleep</p></div>`, html += `<div class="gw-quiz__sr-benefit">${checkSvg}<p class="gw-quiz__sr-benefit-text">Calm <strong>inflammation & stress</strong> so deep sleep can return</p></div>`), benefitsEl.innerHTML = html
            }
        }
        populateSummaryComparison(step) {
            const perceivedAge = this.getPerceivedAge(),
                goalAge = this.getGoalAge(),
                ageAnswer = this.state.answers.age?.value,
                perceivedAgeEl = step.querySelector('[data-field="perceived_age"]');
            perceivedAgeEl && perceivedAge && (perceivedAgeEl.textContent = `${perceivedAge} years`);
            const goalAgeEl = step.querySelector('[data-field="goal_age"]');
            goalAgeEl && goalAge && (goalAgeEl.textContent = `${goalAge} years`);
            const yearsYoungerEl = step.querySelector('[data-field="years_younger"]');
            if (yearsYoungerEl && perceivedAge && goalAge) {
                const yearsDiff = perceivedAge - goalAge;
                yearsYoungerEl.textContent = `${yearsDiff}+ years`
            }
            const ageImages = this.config.ageImages || {},
                nowImageUrl = ageAnswer ? ageImages[ageAnswer] : null;
            if (nowImageUrl && nowImageUrl.length > 0) {
                const nowImg = step.querySelector('[data-image-type="now"]');
                if (nowImg) {
                    nowImg.style.backgroundImage = `url('${nowImageUrl}')`;
                    const placeholder = nowImg.querySelector(".gw-quiz__comparison-card-placeholder");
                    placeholder && (placeholder.style.display = "none")
                }
                const currentAgeIndex = AGE_ORDER.indexOf(ageAnswer),
                    goalAgeIndex = Math.max(0, currentAgeIndex - 2);
                let goalImageUrl;
                if (currentAgeIndex === 0) goalImageUrl = ageImages.youngest_goal;
                else {
                    const goalAgeKey = AGE_ORDER[goalAgeIndex];
                    goalImageUrl = ageImages[goalAgeKey]
                }
                const goalImg = step.querySelector('[data-image-type="goal"]');
                if (goalImg && goalImageUrl && goalImageUrl.length > 0) {
                    goalImg.style.backgroundImage = `url('${goalImageUrl}')`;
                    const placeholder = goalImg.querySelector(".gw-quiz__comparison-card-placeholder");
                    placeholder && (placeholder.style.display = "none")
                }
            }
        }
        populateInfoStep(step) {
            const subheadlineEl = step.querySelector(".gw-quiz__subheadline--dynamic");
            if (subheadlineEl) {
                const template = subheadlineEl.dataset.subheadlineTemplate || subheadlineEl.textContent,
                    problemAreasText = this.getProblemAreasTextBold(),
                    content = template.replace("{problem_areas}", problemAreasText);
                subheadlineEl.innerHTML = content
            }
            const testimonialCarousel = step.querySelector("[data-testimonial-carousel]");
            if (testimonialCarousel && !testimonialCarousel.dataset.initialized) {
                const track = testimonialCarousel.querySelector("[data-testimonial-track]"),
                    prevBtn = testimonialCarousel.querySelector("[data-testimonial-prev]"),
                    nextBtn = testimonialCarousel.querySelector("[data-testimonial-next]");
                if (track && prevBtn && nextBtn) {
                    const scrollAmount = () => {
                        const card = track.querySelector(".gw-quiz__testimonial-card");
                        return card ? card.offsetWidth + 16 : 296
                    };
                    prevBtn.addEventListener("click", () => {
                        track.scrollBy({
                            left: -scrollAmount(),
                            behavior: "smooth"
                        })
                    }), nextBtn.addEventListener("click", () => {
                        track.scrollBy({
                            left: scrollAmount(),
                            behavior: "smooth"
                        })
                    })
                }
                testimonialCarousel.dataset.initialized = "true"
            }
        }
        populateOfferStep(step) {
            const answers = this.state.answers,
                personalizedEl = step.querySelector("[data-offer-personalized]");
            if (personalizedEl) {
                const concerns = this.getProblemAreasTextBold(3),
                    severity = answers.severity,
                    severityLabel = severity ? severity.label : "",
                    fallbackFocus = this.answerValues("frustrations_recent").length > 0 || !!answers.life_change_priority?.value || !!answers.life_stage ? "cortisol & inflammation" : "grounding",
                    recommendName = (step.getAttribute("data-offer-product-label") || "").trim() || "GroundingWell Grounding Sleep System";
                let text = `Based on your <strong>${severityLabel||fallbackFocus}</strong> concerns with ${concerns}, we recommend <strong>${recommendName}</strong>.`;
                personalizedEl.innerHTML = text
            }
            const benefitsEl = step.querySelector("[data-offer-benefits]");
            if (benefitsEl) {
                const checkSvg = '<svg class="gw-quiz__offer-benefit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
                    benefitMap = {
                        beer_belly: "Targets <strong>stubborn belly fat</strong> by supporting healthy hormone balance",
                        man_boobs: "Helps ease <strong>upper-body softness</strong> by supporting estrogen balance",
                        low_t: "Clinically-studied ingredients to <strong>support natural hormone production</strong>",
                        high_cortisol: "Adaptogenic herbs that <strong>lower cortisol</strong> and reduce stress-related fat storage",
                        low_energy: "Restores <strong>energy, calm focus & intimacy</strong> so you feel like yourself again",
                        low_muscle: "Supports <strong>lean muscle growth</strong> and faster recovery from workouts"
                    },
                    frustrationOfferMap = {
                        stubborn_weight_gain: "Targets <strong>stubborn menopause weight</strong> by calming the cortisol that stores it",
                        aching_joints: "Eases <strong>aching joints & stiffness</strong> by lowering inflammation overnight",
                        poor_sleep: "Rebuilds <strong>deep, restorative sleep</strong> by resyncing your cortisol rhythm",
                        hot_flashes_night_sweats: "Designed to cool <strong>hot flashes & night sweats</strong> as the nervous system settles",
                        mood_swings_brain_fog: "Supports a <strong>calmer mind & steadier mood</strong> out of fight-or-flight",
                        loss_libido: "Nurtures <strong>vitality & desire</strong> as stress drops and sleep returns",
                        not_myself: "Helps you feel <strong>more like yourself</strong> from the first grounded night"
                    },
                    defaultBenefits = ["<strong>95% organic cotton + pure silver threading</strong> \u2014 conductive, breathable & machine-washable", "Reconnects you to the Earth's electrons <strong>passively, all night</strong> \u2014 nothing to swallow", "<strong>30-day money-back guarantee</strong> \u2014 zero risk to try"];
                let benefits = [];
                const problemAreas = answers.problem_areas;
                problemAreas && Array.isArray(problemAreas) && problemAreas.slice(0, 3).forEach(p => {
                    const benefit = benefitMap[p.value];
                    benefit && benefits.push(benefit)
                }), this.answerValues("frustrations_recent").slice(0, 3).forEach(v => {
                    const benefit = frustrationOfferMap[v];
                    benefit && !benefits.includes(benefit) && benefits.push(benefit)
                });
                const lifeChangeOfferMap = {
                    sleep_through_night: "Helps you stack habits that invite <strong>longer, unbroken sleep windows</strong>",
                    joint_relief: "Targets <strong>stiff, aching joints</strong> by calming inflammation as you sleep",
                    belly_fat_loss: "Helps ease the <strong>menopause belly</strong> by lowering cortisol-driven storage",
                    emotional_balance: "Supports <strong>calmer moods & sharper focus</strong> out of fight-or-flight",
                    hot_flashes_ease: "Designed to cool <strong>hot flashes & night sweats</strong> as your system rebalances",
                    feel_like_myself: "Helps reclaim that quiet \u201Cthat\u2019s me\u201D feeling as systems rebalance"
                };
                this.answerValues("life_change_priority").slice(0, 3).forEach(v => {
                    const benefit = lifeChangeOfferMap[v];
                    benefit && !benefits.includes(benefit) && benefits.push(benefit)
                });
                const supplementTime = answers.supplement_time;
                supplementTime && supplementTime.value === "morning" ? benefits.push("Just <strong>lay it on your bed and sleep</strong> \u2014 fits your nightly routine") : supplementTime && benefits.push("Simple nightly routine \u2014 <strong>just sleep on it</strong>");
                const motivation = answers.motivation;
                motivation && motivation.value === "very_motivated" && benefits.push("Your <strong>high motivation</strong> combined with our formula = fastest results"), benefits.length < 3 && defaultBenefits.forEach(b => {
                    benefits.length < 5 && !benefits.includes(b) && benefits.push(b)
                }), benefits = benefits.slice(0, 5);
                let html = '<p class="gw-quiz__offer-benefits-title">Why this is perfect for you</p>';
                benefits.forEach(b => {
                    html += `<div class="gw-quiz__offer-benefit">${checkSvg}<p class="gw-quiz__offer-benefit-text">${b}</p></div>`
                }), benefitsEl.innerHTML = html
            }
        }
        initOfferCarousel(step) {
            const carousel = step.querySelector("[data-offer-carousel]");
            if (!carousel || carousel.dataset.carouselInit) return;
            carousel.dataset.carouselInit = "true";
            const slides = carousel.querySelector("[data-offer-slides]"),
                slideEls = Array.from(slides.children),
                thumbs = step.querySelectorAll("[data-thumb-index]"),
                prevBtn = carousel.querySelector("[data-carousel-prev]"),
                nextBtn = carousel.querySelector("[data-carousel-next]");
            let current = 0;
            const total = slideEls.length,
                goTo = index => {
                    current = Math.max(0, Math.min(index, total - 1)), slides.style.transform = `translateX(-${current*100}%)`, slideEls.forEach((s, i) => s.classList.toggle("is-active", i === current)), thumbs.forEach((t, i) => t.classList.toggle("is-active", i === current))
                };
            prevBtn && prevBtn.addEventListener("click", () => goTo(current - 1)), nextBtn && nextBtn.addEventListener("click", () => goTo(current + 1)), thumbs.forEach(thumb => {
                thumb.addEventListener("click", () => goTo(parseInt(thumb.dataset.thumbIndex, 10)))
            });
            let startX = 0,
                diffX = 0;
            carousel.addEventListener("touchstart", e => {
                startX = e.touches[0].clientX, diffX = 0
            }, {
                passive: !0
            }), carousel.addEventListener("touchmove", e => {
                diffX = e.touches[0].clientX - startX
            }, {
                passive: !0
            }), carousel.addEventListener("touchend", () => {
                Math.abs(diffX) > 40 && goTo(diffX > 0 ? current - 1 : current + 1)
            })
        }
        getProblemAreasTextBold(limit = 3) {
            const problemAreas = this.state.answers.problem_areas;
            if (problemAreas && Array.isArray(problemAreas) && problemAreas.length > 0) return "<strong>" + problemAreas.slice(0, limit).map(p => PROBLEM_LABELS[p.value] || p.label).join(" & ") + "</strong>";
            const fr = this.answerValues("frustrations_recent");
            return fr.length > 0 ? "<strong>" + fr.slice(0, limit).map(v => FRUSTRATION_LABELS[v] || v.replace(/_/g, " ")).join(" & ") + "</strong>" : "<strong>your concerns</strong>"
        }
        handleLoadingStep(step) {
            const duration = parseInt(step.dataset.duration, 10) || 3e3,
                checklist = step.querySelector(".gw-quiz__checklist");
            checklist && Array.from(checklist.querySelectorAll(".gw-quiz__checklist-item")).forEach((item, i) => {
                const delay = parseInt(item.dataset.delay, 10) || i * 1e3,
                    timer = setTimeout(() => {
                        item.classList.add("is-visible"), setTimeout(() => {
                            item.classList.add("is-complete")
                        }, 500)
                    }, delay);
                this.checklistTimers.push(timer)
            }), this.autoAdvanceTimer = setTimeout(() => {
                this.nextStep()
            }, duration)
        }
        clearTimers() {
            this.autoAdvanceTimer && (clearTimeout(this.autoAdvanceTimer), this.autoAdvanceTimer = null), this.checklistTimers.forEach(t => clearTimeout(t)), this.checklistTimers = []
        }
        handleSkip(btn) {
            const questionId = btn.closest(".gw-quiz__step")?.dataset.questionId;
            questionId && this.state.answers[questionId] && (delete this.state.answers[questionId], this.saveState()), this.nextStep()
        }
        handleClaimOffer(btn) {
            const productUrl = btn.dataset.productUrl,
                variantId = btn.dataset.variantId,
                sellingPlanId = btn.dataset.sellingPlanId,
                discountCode = btn.closest(".gw-quiz__step")?.dataset.discountCode,
                params = new URLSearchParams;
            Object.entries(this.state.answers).forEach(([key, value]) => {
                Array.isArray(value) ? params.set(key, value.map(v => v.value).join(",")) : value && value.value && params.set(key, value.value)
            }), variantId && params.set("variant", variantId), sellingPlanId && params.set("selling_plan", sellingPlanId), discountCode && params.set("discount", discountCode);
            let url = this.redirectUrl || productUrl;
            if (url) {
                const separator = url.includes("?") ? "&" : "?";
                window.location.href = `${url}${separator}${params.toString()}`
            }
        }
        saveState() {
            try {
                localStorage.setItem(`gw-quiz-${this.sectionId}`, JSON.stringify(this.state))
            } catch (e) {
                console.warn("Could not save quiz state:", e)
            }
        }
        loadState() {
            try {
                const saved = localStorage.getItem(`gw-quiz-${this.sectionId}`);
                if (saved) {
                    const parsed = JSON.parse(saved);
                    this.state.answers = parsed.answers || {}
                }
            } catch (e) {
                console.warn("Could not load quiz state:", e)
            }
        }
        clearState() {
            try {
                localStorage.removeItem(`gw-quiz-${this.sectionId}`)
            } catch (e) {
                console.warn("Could not clear quiz state:", e)
            }
        }
        capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1)
        }
        destroy() {
            this.clearTimers()
        }
    }

    function initQuizzes() {
        document.querySelectorAll('[data-section-type="gw-quiz"]').forEach(container => {
            container.gwQuiz || (container.gwQuiz = new gwQuiz(container))
        })
    }
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", initQuizzes) : initQuizzes(), document.addEventListener("shopify:section:load", e => {
        const container = e.target.querySelector('[data-section-type="gw-quiz"]');
        container && (container.gwQuiz = new gwQuiz(container))
    }), document.addEventListener("shopify:section:unload", e => {
        const container = e.target.querySelector('[data-section-type="gw-quiz"]');
        container && container.gwQuiz && container.gwQuiz.destroy()
    })
})();